import React, { Component } from 'react'

export default class Footer extends Component {
    render() {
        return (
            <>
                <footer className="mb-3">
                    <hr />
                    <div className="container">
                        <div className="row">
                            <div className="col fs-6 text-center text-dark">2022 Copyright&copy; Putrapt</div>
                        </div>
                    </div>
                </footer>
            </>

        )
    }
}